// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SingleLink_wrapper__jNW7Z","link":"SingleLink_link__3koy7"};